define("shared/utils/media-adjustments/media-adjustments-routing", ["exports", "shared/utils/media-adjustments/build-media-spec-params", "shared/utils/media-adjustments/has-persisted-record", "shared/utils/media-adjustments/has-unsaved-media-spec-changes"], function (_exports, _buildMediaSpecParams, _hasPersistedRecord, _hasUnsavedMediaSpecChanges) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.canLoadMediaAdjustments = canLoadMediaAdjustments;
  _exports.resolveMediaAdjustmentsSource = resolveMediaAdjustmentsSource;
  _exports.shouldUsePersistedMediaAdjustmentsEndpoint = shouldUsePersistedMediaAdjustmentsEndpoint;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/media-adjustments/build-media-spec-params",0,"shared/utils/media-adjustments/has-persisted-record",0,"shared/utils/media-adjustments/has-unsaved-media-spec-changes"eaimeta@70e063a35619d71f
  function shouldUsePersistedMediaAdjustmentsEndpoint(postMediaItem) {
    return (0, _hasPersistedRecord.hasPersistedRecord)(postMediaItem) && !(0, _hasUnsavedMediaSpecChanges.hasUnsavedMediaSpecChanges)(postMediaItem);
  }
  function canLoadMediaAdjustments(postMediaItem, post) {
    return (0, _hasPersistedRecord.hasPersistedRecord)(postMediaItem) || Boolean((0, _buildMediaSpecParams.buildMediaSpecParams)(postMediaItem, post)?.media_item_id);
  }
  function resolveMediaAdjustmentsSource(postMediaItem, post) {
    if (shouldUsePersistedMediaAdjustmentsEndpoint(postMediaItem)) {
      return {
        kind: 'persisted'
      };
    }
    const spec = (0, _buildMediaSpecParams.buildMediaSpecParams)(postMediaItem, post);
    if (!spec) {
      if ((0, _hasPersistedRecord.hasPersistedRecord)(postMediaItem)) {
        return {
          kind: 'persisted'
        };
      }
      return {
        kind: 'unavailable'
      };
    }
    const {
      media_item_id: mediaItemId,
      ...requestParams
    } = spec;
    return {
      kind: 'media-item',
      mediaItemId,
      requestParams
    };
  }
});